var librariesInfo = [
    { jsfilename: "Scripts/GOjs/go.js?v=" + EMRVersionNumber, downloaded: false, fileid: 5500 },
    { jsfilename: "Scripts/KendoUI/kendo.timezones.min.js", downloaded: false, fileid: 520006 },
    { jsfilename: "UITheme/js/SummerNote/summernote.js", downloaded: false, fileid: 80001 },
    //{ jsfilename: "Scripts/Calendar/fullcalendar.js", downloaded: false, fileid: 80002 },not using
    { jsfilename: "Scripts/EasyFormIpadSignaturePad/signature_pad.js", downloaded: false, fileid: 80003 },
    { jsfilename: "Scripts/d3js/d3.min.js", downloaded: false, fileid: 80004 },
    { jsfilename: "Scripts/Scanner/scanner.js", downloaded: false, fileid: 80005 },
    { jsfilename: "Scripts/fabric/fabric.min.js", downloaded: false, fileid: 80006 },
    { jsfilename: "Scripts/jquery.scannerdetection.js", downloaded: false, fileid: 80007 },
    { jsfilename: "UITheme/js/bootstrap/responsive-tabs.js", downloaded: false, fileid: 80008 },
];
